import { useEffect, useRef, useState } from "react";

// Tiny IntersectionObserver hook to add `.in-view` to .reveal elements
export const useReveal = (options = { threshold: 0.15 }) => {
  const ref = useRef(null);
  const [inView, setInView] = useState(false);

  useEffect(() => {
    const node = ref.current;
    if (!node) return;
    const obs = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            setInView(true);
            node.classList.add("in-view");
            obs.unobserve(node);
          }
        });
      },
      options
    );
    obs.observe(node);
    return () => obs.disconnect();
  }, [options]);

  return [ref, inView];
};
